/* eslint-disable */
import getMedals from '../../api/medals';
import * as C from './constants';

export function loadMedals() {
    return {
        type: 'PROMISE',
        actions: [
            C.START_LOAD_MEDALS,
            C.FINISH_LOAD_MEDALS,
            C.ERROR_LOAD_MEDALS
        ],
        promise: getMedals()
    };
}



// WEBPACK FOOTER //
// ./src/models/medals/actions.js